import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.AccountBillingDispute1,
  LocationVarKey.AccountBillingDispute2,
  {
    key: LocationVarKey.AfterNavigateAccountLoginBillingDispute,
    hideIf: IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")
  },
  {
    key: LocationVarKey.AfterNavigateAccountLoginBillingDispute1,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginBillingDispute, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  },
  {
    key: LocationVarKey.AfterNavigateAccountLoginBillingDispute2,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginBillingDispute, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        Billing Dispute
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AccountBillingDispute1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.AccountBillingDispute2}
        enableSwitchVar={LocationVarKey.AccountBillingDispute2Enabled}
      />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.AfterNavigateAccountLoginBillingDispute}
          label="Ask if they want to be navigated to your Account Login URL"
        />
        <Section
          {...page}
          hideIf={IF_ANY([
            IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginBillingDispute, "1"),
            IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
          ])}
        >
          <SectionHeader
            {...page}
            subheading="After navigating the customer to a new page, the chat will open and respond based on the information below."
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginBillingDispute, "1")}
          >
            {" "}
            After Navigate{" "}
          </SectionHeader>
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginBillingDispute, "1")}
            marginTop
            label=" Message 1"
            keyName={LocationVarKey.AfterNavigateAccountLoginBillingDispute1}
          />
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginBillingDispute, "1")}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateAccountLoginBillingDispute2}
            enableSwitchVar={LocationVarKey.AfterNavigateAccountLoginBillingDispute2Enabled}
          />
        </Section>
      </Section>
    </>
  );
}
